import { PageBreadcrumb } from "@/components/PageBreadcrumb";

/**
 * Standard page frame: breadcrumb -> title + description -> primary action -> filters.
 * Props are backward compatible; `filters` (node) is new and renders under the title row.
 */
export function PageHeader({ title, description, action, testId, icon: Icon, breadcrumb, filters }) {
  return (
    <div data-testid={testId} data-tour="page-title" className="space-y-2 border-b border-border pb-3">
      <PageBreadcrumb crumbs={breadcrumb} />
      <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
        <div className="flex min-w-0 items-start gap-3">
          <div className="min-w-0">
            <h1 className="text-xl font-semibold tracking-tight text-foreground">{title}</h1>
            {description && <p className="mt-0.5 max-w-3xl text-sm leading-snug text-muted-foreground line-clamp-2">{description}</p>}
          </div>
        </div>
        {action && <div className="flex shrink-0 flex-wrap items-center gap-2">{action}</div>}
      </div>
      {filters && <div className="pt-1">{filters}</div>}
    </div>
  );
}
